import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

document.addEventListener('DOMContentLoaded', () => {

    // Fade up elements animation
    const fadeUpElements = document.querySelectorAll('.anmi-fadeup');
    fadeUpElements.forEach((element, index) => {
        gsap.from(element, {
            scrollTrigger: {
                trigger: element,
                start: 'top 80%',
                toggleActions: 'play none none none',
            },
            duration: 1,
            opacity: 0,
            y: 50,
            ease: 'power2.out',
            stagger: 0.15,

        });
    });

	// Fade up elements animation
    const fadeDownElements = document.querySelectorAll('.anmi-fadedown');
    fadeDownElements.forEach((element, index) => {
        gsap.from(element, {
            scrollTrigger: {
                trigger: element,
                start: 'bottom 80%',
                toggleActions: 'play none none none',
            },
            duration: 1,
            opacity: 0,
            y: 50,
            ease: 'power2.out',
            stagger: 0.15,

        });
    });

    // Box fade up animation
    const boxfadeUpElements = document.querySelectorAll('.box-icon');
    boxfadeUpElements.forEach((element, index) => {
        gsap.from(element, {
            scrollTrigger: {
                trigger: element,
                start: 'top-=100 80%',
                toggleActions: 'play none none none',
            },
            duration: 1,
            opacity: 0,
            y: 50,
            ease: 'power2.out',
            stagger: 0.15,
            delay: index * 0.05
        });
    });

    // Fade left elements animation
    const fadeLeftElements = document.querySelectorAll('.anmi-fadeleft');
    fadeLeftElements.forEach((element, index) => {
        gsap.from(element, {
            scrollTrigger: {
                trigger: element,
                start: 'top 80%',
                toggleActions: 'play none none none',
            },
            duration: 1,
            opacity: 0,
            x: -50,
            ease: 'power2.out',
            stagger: 0.15,
            delay: index * 0.15
        });
    });

    // Fade bottom elements animation
    const fadeBottomElements = document.querySelectorAll('.anmi-fadebottom');
    fadeBottomElements.forEach((element, index) => {
        gsap.from(element, {
            scrollTrigger: {
                trigger: element,
                start: 'top 80%',
                toggleActions: 'play none none none',
            },
            duration: 1,
            opacity: 0,
            y: 50,
            ease: 'power2.out',
            stagger: 0.15,
            delay: index * 0.15
        });
    });

    // Fade in elements animation with stagger
    const fadeInElements = document.querySelectorAll('.anmi-fadein');
    if (fadeInElements.length > 0) {
        gsap.fromTo(fadeInElements,
            {
                opacity: 0,
                y: 1
            },
            {
                opacity: 1,
                y: 0,
                duration: 0.8,
                ease: 'power2.out',
                stagger: 0.15,
                scrollTrigger: {
                    trigger: fadeInElements[0],
                    start: 'top 80%',
                    toggleActions: 'play none none none',
                }
            }
        );
    }

	// Fade in elements animation with stagger
    const fadePinElements = document.querySelectorAll('.anmi-pin');
    if (fadePinElements.length > 0) {
        gsap.fromTo(fadePinElements,
            {
                opacity: 0,
                y: 1
            },
            {
                opacity: 1,
                y: 0,
                duration: 0.5,
                ease: 'power2.out',
                stagger: 0.01,
                scrollTrigger: {
                    trigger: fadePinElements[0],
                    start: 'top 80%',
                    toggleActions: 'play none none none',
                }
            }
        );
    }

    // Line up animation - fade from bottom
    const lineUpElements = document.querySelectorAll('.anmi-lineup');
    lineUpElements.forEach((element) => {
        gsap.fromTo(element,
            {
                y: '200%'
            },
            {
                y: '0%',
                duration: 2,
                ease: 'power2.out',
               delay: 0.45,
            }
        );
    });

    // Line down animation - fade from top
    const lineDownElements = document.querySelectorAll('.anmi-linedown');
    lineDownElements.forEach((element) => {
		gsap.fromTo(element,
            {
                y: '-200%'
            },
            {
                y: '0%',
                duration: 2,
                ease: 'sine.inOut',
				delay: 0.45,
            }
        );
    });


        // Hero line animation - grow from center
    const heroLines = document.querySelectorAll('.heroline');
    heroLines.forEach((element) => {
        gsap.fromTo(element,
            {
                scaleX: 0,
                transformOrigin: 'center center'
            },
            {
                scaleX: 1,
                duration: 1.5,
                ease: 'power2.out',
                delay: 0.2,
            }
        );
    });

    // Parrablock scroll animations
    gsap.fromTo('.para-100200',
        { y: -100 },
        {
            y: 200,
            scrollTrigger: {
                trigger: '.parrablock',
                start: 'top bottom',
                end: 'bottom top',
                scrub: true,
            }
        }
    );

    gsap.fromTo('.para100-100',
        { y: 100 },
        {
            y: -100,
            scrollTrigger: {
                trigger: '.parrablock',
                start: 'top bottom',
                end: 'bottom top',
                scrub: true,
            }
        }
    );

    // Parallax scrolling for text
    const parallaxBlock = document.querySelectorAll('.parallax-block');
    parallaxBlock.forEach((textElement) => {
        gsap.fromTo(textElement,
            { y: 50 }, // start position
            {
                y: -50, // end position
                scrollTrigger: {
                    trigger: textElement,
                    start: 'top bottom', // when the text enters the viewport
                    end: 'bottom top', // when the text exits the viewport
                    scrub: true, // smooth scrolling
                }
            }
        );
    });


    // Parallax scrolling for text
    const parallaxText = document.querySelectorAll('.parallax-text');
    parallaxText.forEach((textElement) => {
        gsap.fromTo(textElement,
            { y: 200 }, // start position
            {
                y: 0, // end position
                scrollTrigger: {
                    trigger: textElement,
                    start: 'top bottom', // when the text enters the viewport
                    end: 'bottom top', // when the text exits the viewport
                    scrub: true, // smooth scrolling
                }
            }
        );
    });


});

export default function initInitGsap() {
	gsap.registerPlugin(ScrollTrigger);
}
